import { createPermissions } from '@/services/permissions';

export const PROFILES = {
  Admin_c: { label: 'Owner', isDefault: false, isPublic: false, canManageTeam: true, reportsTo: null },
  Staff_c: { label: 'Staff', isDefault: false, isPublic: false, canManageTeam: false, reportsTo: 'Admin_c' },
  Customer_c: { label: 'Customer', isDefault: true, isPublic: false, canManageTeam: false, reportsTo: 'Admin_c' },
  PublicProfile: { label: 'Visitor', isDefault: false, isPublic: true, canManageTeam: false, reportsTo: null },
};

const ALL_TABLES = [
  'orders_c',
  'customers_c',
  'payments_c',
  'tickets_c',
  'ticket_messages_c',
  'reviews_c',
  'discount_codes_c',
  'contact_messages_c',
  'broadcasts_c',
  'activity_c',
  'announcements_c',
  'templates_c',
  'currencies_c',
  'products_c',
  'ledger_c',
  'credit_rates_c',
  'payment_settings_c',
  'status_services_c',
  'status_links_c',
  'referral_handles_c',
  'referral_visits_c',
  'line_references_c',
  'reference_links_c',
  'email_settings_c',
];

const full = Object.fromEntries(ALL_TABLES.map((t) => [t, { access: 'Full' }]));

const TABLE_PERMISSIONS = {
  Admin_c: full,
  Staff_c: {
    ...full,
    broadcasts_c: { access: 'Inaccessible' },
    activity_c: { access: 'Read,Create' },
    email_settings_c: { access: 'Read' },
  },
  Customer_c: {
    orders_c: {
      access: 'Read,Create,Update,Delete',
      readOnlyFields: [
        'line_server_c',
        'line_username_c',
        'line_password_c',
        'include_epg_c',
        'line_note_c',
        'credentials_sent_at_c',
        'telly_key_c',
        'telly_sent_at_c',
        'activated_at_c',
        'ends_at_c',
        'expiry_emailed_at_c',
        'referral_counted_c',
        'gift_months_c',
        'line_verified_at_c',
        'line_verified_plan_c',
      ],
    },
    customers_c: {
      access: 'Read,Create,Update',
      inaccessibleFields: ['notes_c', 'tags_c'],
      readOnlyFields: ['referrals_earned_c'],
    },
    payments_c: { access: 'Read' },
    tickets_c: { access: 'Read,Create,Update,Delete' },
    ticket_messages_c: { access: 'Read,Create' },
    reviews_c: { access: 'Read,Create,Update,Delete', readOnlyFields: ['reply_c'] },
    discount_codes_c: { access: 'Read', inaccessibleFields: ['customer_c', 'credit_used_c'] },
    contact_messages_c: { access: 'Create' },
    broadcasts_c: { access: 'Inaccessible' },
    activity_c: { access: 'Inaccessible' },
    announcements_c: { access: 'Read' },
    templates_c: { access: 'Inaccessible' },
    currencies_c: { access: 'Read' },
    products_c: { access: 'Read' },
    ledger_c: { access: 'Inaccessible' },
    credit_rates_c: { access: 'Inaccessible' },
    payment_settings_c: { access: 'Read' },
    status_services_c: { access: 'Read' },
    status_links_c: { access: 'Inaccessible' },
    referral_handles_c: { access: 'Read' },
    referral_visits_c: { access: 'Create' },
    line_references_c: { access: 'Read' },
    reference_links_c: { access: 'Inaccessible' },
    email_settings_c: { access: 'Read' },
  },
  PublicProfile: {
    orders_c: { access: 'Inaccessible' },
    customers_c: { access: 'Inaccessible' },
    payments_c: { access: 'Inaccessible' },
    tickets_c: { access: 'Inaccessible' },
    ticket_messages_c: { access: 'Inaccessible' },
    reviews_c: { access: 'Read' },
    discount_codes_c: { access: 'Inaccessible' },
    contact_messages_c: { access: 'Create' },
    broadcasts_c: { access: 'Inaccessible' },
    activity_c: { access: 'Inaccessible' },
    announcements_c: { access: 'Read' },
    templates_c: { access: 'Inaccessible' },
    currencies_c: { access: 'Read' },
    products_c: { access: 'Read' },
    ledger_c: { access: 'Inaccessible' },
    credit_rates_c: { access: 'Inaccessible' },
    payment_settings_c: { access: 'Inaccessible' },
    status_services_c: { access: 'Read' },
    status_links_c: { access: 'Inaccessible' },
    referral_handles_c: { access: 'Inaccessible' },
    referral_visits_c: { access: 'Create' },
    line_references_c: { access: 'Inaccessible' },
    reference_links_c: { access: 'Inaccessible' },
    email_settings_c: { access: 'Inaccessible' },
  },
};

export const { getProfileMeta, getTableAccess, getFieldAccess } = createPermissions(PROFILES, TABLE_PERMISSIONS);

export const isTeamProfile = (profile) => profile === 'Admin_c' || profile === 'Staff_c';
